import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, map, throwError } from 'rxjs';

import { UserOrganigramaSearchPayload } from '../interfaces/common.interface'

@Injectable({
    providedIn: 'root'
})
export class CommonService {

    private token!: string;
    private basePath = environment.interop.basePath;
    private httpOptions: any;
    private getDirectiiUrl = this.basePath + environment.interop.deps.nomenclatoare.directie.getDirectii
    private getDirectiiActiveUrl = this.basePath + environment.interop.deps.nomenclatoare.directie.getDirectiiActive
    private getCompartimenteUrl = this.basePath + environment.interop.deps.nomenclatoare.compartiment.getCompartimente
    private getCompartimenteActiveUrl = this.basePath + environment.interop.deps.nomenclatoare.compartiment.getCompartimenteActive
    private getCompartimenteByDirectieUrl = this.basePath + environment.interop.deps.nomenclatoare.compartiment.getCompartimenteByDirectie
    private getCompartimenteByDepsUrl = this.basePath + environment.interop.deps.nomenclatoare.compartiment.getCompartimenteByDeps
    private getJudeteActiveUrl = this.basePath + environment.interop.deps.nomenclatoare.judet.listActive

    private getUsersByOrganigramaUrl = this.basePath + environment.interop.deps.nomenclatoare.user.getActiveUsersByOrganigrama

    private getFunctiiUrl = this.basePath + environment.interop.deps.nomenclatoare.functiiUser.list;
    private getCerereStatusesActiveUrl = this.basePath + environment.interop.deps.nomenclatoare.cerereStatus.listActive
    private getCererePrioritiesActiveUrl = this.basePath + environment.interop.deps.nomenclatoare.cererePriority.listActive
    private getCerereTypesUrl = this.basePath + environment.interop.deps.nomenclatoare.cerereType.list
    private getCerereTypesActiveUrl = this.basePath + environment.interop.deps.nomenclatoare.cerereType.listActive
    private getLocatiiUrl = this.basePath + environment.interop.deps.nomenclatoare.locatii.list;

    constructor(private http: HttpClient) { }

    getDirectii() {
        // return this.http.get(this.getDirectiiUrl, this.httpOptions);
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getDirectiiUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_directie,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get directii active:', error);
                    return throwError(error);
                })
            );
    }

    getDirectiiActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getDirectiiActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_directie,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get directii active:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimente() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get compartimente:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get compartimente active:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteByDirectieId(id: number) {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteByDirectieUrl + id
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in getCompartimenteByDirectieId:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteByDeps() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteByDepsUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get compartimente by deps:', error);
                    return throwError(error);
                })
            );
    }

    getJudeteActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getJudeteActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get judete active:', error);
                    return throwError(error);
                })
            );
    }

    getUsersByOrganigrama(data: UserOrganigramaSearchPayload) {
        return this.http
            .post<{ errors: boolean; data: any[]; status_code: number }>(this.getUsersByOrganigramaUrl, data, this.httpOptions)
            .pipe(
                map((response: any) =>
                    response.data.map((item: any) => ({ id: item.id, name: item.name }))
                ),
                catchError((error) => {
                    console.error('Error in getUserTypeActive:', error);
                    return throwError(error);
                })
            );
    }

    getCerereStatusesActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCerereStatusesActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                        archive: item.archive,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request statuses active:', error);
                    return throwError(error);
                })
            );
    }

    getCererePrioritiesActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCererePrioritiesActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request priorities active:', error);
                    return throwError(error);
                })
            );
    }

    getCerereTypesActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCerereTypesActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request types active:', error);
                    return throwError(error);
                })
            );
    }

    getCerereTypesByComp(id: number) {
        let payload = { compartiment: id };

        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCerereTypesUrl, { params: payload }
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request types by comp:', error);
                    return throwError(error);
                })
            );
    }

    getFunctii() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getFunctiiUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get functii:', error);
                    return throwError(error);
                })
            );
    }

    getLocatii() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getLocatiiUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_locatie,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get locatii:', error);
                    return throwError(error);
                })
            );
    }
}
